<div hidden>
  <label for="{{history.id}}--readonly">
    {{history.name}}
  </label>
  <div *ngIf="history.filled">
    <textarea pInputTextarea name="{{history.id}}--readonly" [(ngModel)]="history.details" [rows]="2" validation
      [readonly]="true" [required]="history.filled">
    </textarea>
  </div>
</div>